import React from 'react'

import { getFeatureCards } from '../../../helpers/getFeatureCards'
//
import { ButtonNew, ThreeCardsWithImage } from '../../../storybook'
import { LocationContext } from '../../page-wrapper'
import { getUrl } from '@/src/utils/urls'
import { useNavigationData } from '@/src/context/NavigationContext'

const Block3CardsWithImage = ({ data: { title, preface, featureCards, action, theme, image } }) => {
  const location = React.useContext(LocationContext)
  const { slugPrefix } = location
  const { navigationItems } = useNavigationData()
  const features = getFeatureCards(featureCards, slugPrefix)

  return (
    <ThreeCardsWithImage
      {...{ title, eyebrow: preface, theme, features, image }}
      action={
        action && (
          <ButtonNew
            trackingId={action?.trackingId}
            url={getUrl({
              navItem: action,
              slugPrefix: slugPrefix,
              navigationItems: navigationItems
            })}
            classes="c-cards-with-image__header-action"
            variant={theme === 'light' ? 'primary' : 'green'}
            icon="ti-arrow-narrow-right"
          >
            {action?.title}
          </ButtonNew>
        )
      }
    ></ThreeCardsWithImage>
  )
}

export default Block3CardsWithImage
